import React from "react";
import classNames from "classnames";

import { default as MultiSelect } from "components/Input/MultiSelect";
import Select from "components/Input/Select";
import GraphStyleSelector from "./GraphStyleSelector";
import Checkbox from "components/Input/Checkbox";
import ExportDataButton from "../ExportDataButton";
import classes from "./styles.module.scss";

const CommResultsFilters = ({
    modelsOptions = [],
    selectedModels = [],
    setSelectedModels,
    selectedMetric,
    setSelectedMetric,
    selectedPV = [],
    setSelectedPV,
    graphStyle,
    setGraphStyle,
    applyModelResultMultiplier,
    setApplyModelResultMultiplier,
    onExportChartData = () => {},
    onExportRawResults = () => {},
    isLoadingCsvData = false,
    exportDisabled = false,
}) => {
    return (
        <div className={classes.filtersContainer}>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Model:</div>
                <MultiSelect
                    idPrefix="results-header-models"
                    className={classes.filterSelect}
                    options={modelsOptions}
                    input={{
                        value: selectedModels,
                        onChange: (value) => setSelectedModels(value),
                    }}
                    dropdownStyles={{ top: "2rem", width: "167px", zIndex: 100 }}
                    hasSelectAll={true}
                    forcedLabel={
                        selectedModels.length === modelsOptions.length
                            ? "All Models"
                            : `${selectedModels.length} Selected`
                    }
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>Metric:</div>
                <Select
                    className={classes.filterSelect}
                    options={[
                        {
                            label: "Energy ",
                            value: "energy",
                        },
                        {
                            label: "Emissions",
                            value: "opEmissions",
                        },
                        {
                            label: "Operating Cost",
                            value: "opCost",
                        },
                    ]}
                    input={{
                        value: selectedMetric,
                        onChange: (value) => setSelectedMetric(value),
                    }}
                />
            </div>
            <div className={classes.filterWrapper}>
                <div className={classes.filterLabel}>PV:</div>
                <MultiSelect
                    idPrefix="results-header-models"
                    className={classes.filterSelect}
                    options={[
                        {
                            value: false,
                            label: "Without",
                        },
                        {
                            value: true,
                            label: "With",
                        },
                    ]}
                    input={{
                        value: selectedPV,
                        onChange: (value) => setSelectedPV(value),
                    }}
                    dropdownStyles={{ top: "2rem", width: "167px", zIndex: 100 }}
                    // hasSelectAll={true}
                    forcedLabel={
                        selectedPV.length === 2
                            ? "With & Without"
                            : selectedPV.length === 1
                              ? `${selectedPV[0] ? "With" : "Without"}`
                              : `${selectedPV.length} Selected`
                    }
                />
            </div>
            <div className={classes.filterWrapper} style={{ opacity: selectedMetric === "opEmissions" ? 0.5 : 1 }}>
                <div className={classes.filterLabel}>Style:</div>
                <GraphStyleSelector graphStyle={graphStyle} setGraphStyle={setGraphStyle} />
            </div>
            <div className={classes.filterWrapper}>
                <Checkbox
                    label="Include Duplicates"
                    input={{
                        value: applyModelResultMultiplier,
                        onChange: (value) => setApplyModelResultMultiplier(value),
                    }}
                    large
                />
            </div>
            <div className={classNames(classes.filterWrapper, classes.exportWrapper)}>
                <ExportDataButton
                    onExportChartData={onExportChartData}
                    onExportRawResults={onExportRawResults}
                    disabled={exportDisabled}
                    isLoading={isLoadingCsvData}
                />
            </div>
        </div>
    );
};

export default CommResultsFilters;
